// React
import React from 'react';
// Material-UI
import { Grid } from '@material-ui/core';
// Otras libs

// Componentes

// Vistas

// Servicios

// Funciones

// Hooks


/**
 * Sección destinada a los filtros que tendrá el contenedor
 * @param {ChildrenFn} props.children
 * @returns 
 */
export const FiltrosContenedor = ({ 
    children,
}) => {
    // Idioma
    
    // Token
    
    // Estados

    // Paginador

    // Listas
    
    // Funciones
    
    // Otros

    // Vista
    return (
        <Grid container spacing={2}>
            {React.Children.map(children, (child) => (
                (child && (
                    <Grid item xs={12} md={4}>
                        {React.cloneElement(child)}
                    </Grid>
                ))
            ))}
        </Grid>
    );
};

/* <Box display="flex" flexWrap="wrap">
{React.Children.map(children, (child) => (
    <Box m={1} minWidth="200px" maxWidth="300px">
        {React.cloneElement(child)}
    </Box>
))}
</Box>
*/